import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export function IngredientForm({ item, onClose, authAxios }) {
  const [name, setName] = useState(item?.name || "");
  const [unit, setUnit] = useState(item?.unit || "kg");
  const [currentQty, setCurrentQty] = useState(item?.current_quantity?.toString() || "");
  const [minQty, setMinQty] = useState(item?.min_quantity?.toString() || "0");
  const [cost, setCost] = useState(item?.cost_per_unit?.toString() || "0");
  const [supplier, setSupplier] = useState(item?.supplier || "");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        name,
        unit,
        current_quantity: parseFloat(currentQty),
        min_quantity: parseFloat(minQty),
        cost_per_unit: parseFloat(cost),
        supplier,
      };
      if (item?.id) {
        await authAxios.put(`/stock/${item.id}`, payload);
        toast.success("Ingrediente actualizado");
      } else {
        await authAxios.post("/stock", payload);
        toast.success("Ingrediente creado");
      }
      onClose();
    } catch {
      toast.error("Error");
    }
    setLoading(false);
  };

  return (
    <>
      <DialogHeader>
        <DialogTitle>{item?.id ? "Editar" : "Nuevo"} Ingrediente</DialogTitle>
      </DialogHeader>
      <form onSubmit={handleSubmit} className="space-y-4 mt-4">
        <div className="space-y-2">
          <Label>Nombre</Label>
          <Input value={name} onChange={e => setName(e.target.value)} required data-testid="ingredient-name" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Unidad</Label>
            <Select value={unit} onValueChange={setUnit}>
              <SelectTrigger data-testid="ingredient-unit"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="kg">Kilogramos</SelectItem>
                <SelectItem value="g">Gramos</SelectItem>
                <SelectItem value="l">Litros</SelectItem>
                <SelectItem value="ml">Mililitros</SelectItem>
                <SelectItem value="unidad">Unidades</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Cantidad actual</Label>
            <Input type="number" step="0.01" value={currentQty} onChange={e => setCurrentQty(e.target.value)} required data-testid="ingredient-qty" />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Stock minimo</Label>
            <Input type="number" step="0.01" value={minQty} onChange={e => setMinQty(e.target.value)} data-testid="ingredient-min" />
          </div>
          <div className="space-y-2">
            <Label>Coste/unidad</Label>
            <Input type="number" step="0.01" value={cost} onChange={e => setCost(e.target.value)} data-testid="ingredient-cost" />
          </div>
        </div>
        <div className="space-y-2">
          <Label>Proveedor</Label>
          <Input value={supplier} onChange={e => setSupplier(e.target.value)} placeholder="Opcional" />
        </div>
        <DialogFooter>
          <Button type="button" variant="secondary" onClick={onClose}>Cancelar</Button>
          <Button type="submit" disabled={loading} data-testid="ingredient-save">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Guardar"}
          </Button>
        </DialogFooter>
      </form>
    </>
  );
}
